import { rem } from "polished"

const cookiesConsent = {
  textColor: ({ theme }) => theme.colors.white,
  borderColor: ({ theme }) => theme.colors.black,
  backgroundColor: ({ theme }) => theme.colors.firefly,
  br: rem(5),
  buttonFont: ({ theme }) => theme.fonts.set(`primary`, `bold`),
  buttonTextColor: ({ theme }) => theme.colors.firefly,
  buttonBackgroundColor: ({ theme }) => theme.colors.white,
  buttonBr: rem(8),
}

export default cookiesConsent
